// Canonical formatter for the items card + preview.
// RentalInvoiceItemRow and RentalInvoiceTotalsCard intentionally differ in
// fallback behavior and keep their own helpers.
export const formatCurrency = (value) => {
  const number = typeof value === "number" ? value : parseFloat(String(value));
  if (isNaN(number)) return "$0.00";
  return number.toLocaleString("en-US", { style: "currency", currency: "USD" });
};
